/** Mirrors backend `BookingSchedule.parseVisitorNameFromExternal`. */
export function parseVisitorNameFromExternal(fullName?: string | null): {
  firstName: string | null;
  surname: string | null;
} {
  if (!fullName?.trim()) {
    return { firstName: null, surname: null };
  }
  const parts = fullName.trim().split(" ");
  if (parts.length === 1) {
    return { firstName: parts[0], surname: null };
  }
  return {
    firstName: parts.slice(0, -1).join(" "),
    surname: parts.at(-1) ?? null
  };
}
